import { useAuth0 } from "@auth0/auth0-react";
import { Trans } from "@lingui/react/macro";

import { BackgroundContainer } from "@/common/components/background-container/background-container";
import { Button } from "@/common/components/button/button";

const Anonymous = () => {
  const auth0 = useAuth0();

  return (
    <BackgroundContainer>
      <div className="flex gap-4">
        <Button
          onClick={() =>
            auth0.loginWithRedirect({
              appState: {
                returnTo: window.location.href,
              },
              authorizationParams: {
                screen_hint: "signup",
              },
            })
          }
          variant="secondary"
        >
          <Trans>Registrovat se</Trans>
        </Button>
        <Button
          onClick={() =>
            auth0.loginWithRedirect({
              appState: {
                returnTo: window.location.href,
              },
            })
          }
          variant="primary"
        >
          <Trans>Přihlásit se</Trans>
        </Button>
      </div>
    </BackgroundContainer>
  );
};

export { Anonymous };
